<template>
  <div class="formWrapper">
    <div class="form-control">
      <input
        v-model="currentPassword"
        :class="{ 'error-boarder': $v.currentPassword.$error }"
        :type="currentPasswordFieldType"
        name="currentPassword"
        :placeholder="$t('currentPassword')"
        @blur="$v.currentPassword.$touch()"
		data-qa="oldPasswordInput"
        v-on="$listeners"
        v-on:input="resetErrorMessage"
        value
      />
      <i class="fas fa-lock"></i>
      <button class="eyeIcon" type="currentPassword" @click="switchVisibility('current')">
        <span class="input-group-text" @click="showCurrentPassword = !showCurrentPassword">
          <i
            class="fa"
            :class="[showCurrentPassword ? 'fa-eye-slash' : 'fa-eye']"
            aria-hidden="true"
          ></i>
        </span>
      </button>
    </div>
    <template v-if="$v.currentPassword.$error">
			<div v-if="!$v.currentPassword.required" class="errorMessage">{{ $t('currPassReq') }}</div>
		</template>

    <div class="form-control">
      <input
        v-model="newPassword"
        :class="{ 'error-boarder': $v.newPassword.$error }"
        :type="newPasswordFieldType"
        name="newPassword"
		data-qa="newPasswordInput"
        :placeholder="$t('newPassword')"
        @blur="$v.newPassword.$touch()"
        v-on="$listeners"
        v-on:input="resetErrorMessage"
        value
      />
      <i class="fas fa-lock"></i>
      <button class="eyeIcon" type="newPassword" @click="switchVisibility('new')">
        <span class="input-group-text" @click="showNewPassword = !showNewPassword">
          <i
            class="fa"
            :class="[showNewPassword ? 'fa-eye-slash' : 'fa-eye']"
            aria-hidden="true"
          ></i>
        </span>
      </button>
    </div>
    <template v-if="$v.newPassword.$error">
			<div v-if="!$v.newPassword.required" class="errorMessage">{{ $t('newPassReq') }}</div>
	</template>
	<template v-if="$v.newPassword.$invalid">
		<p v-if="!$v.newPassword.maxLength" class="errorMessage">
			{{ $t('passMaxLength') }}
		</p>
	</template>
	<template v-if="$v.newPassword.$invalid">
		<p v-if="!$v.newPassword.minLength" class="errorMessage">
			{{ $t('passMinLength') }}
		</p>
	</template>
	<template v-if="this.submitted && $v.newPassword.$error">
		<p v-if="newPassword && !$v.newPassword.valid" class="errorMessage">
			{{ $t('passValid') }}
		</p>
	</template>
    <p>
      <button
        class="login-btn"
        sytle="text-transform: uppercase;"
        :disabled="$v.$invalid"
        @click="ChangePassword"
      >
        {{ $t('update') }}
      </button>
    </p>
    <sweet-modal icon="success" ref="modalSuccess" name="successModal">
      <p v-if="response">{{ response.message }}</p>
    </sweet-modal>
    <sweet-modal icon="error" ref="modalError" name="errorModal">
      <p v-if="response">{{ response.message }}</p>
    </sweet-modal> 
  </div>
</template>

<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { SweetModal } from 'sweet-modal-vue'

export default {
components: {
    SweetModal,
},
data() {
    return {
      currentPassword: '',
      newPassword: '',
      currentPasswordFieldType: 'password',
      showCurrentPassword: false,
      newPasswordFieldType: 'password',
      showNewPassword: false,
	  errors: null,
      error: false,
	  submitted: false,
      response: {}
    }
},
validations: {
    currentPassword: {
      required,
    },
    newPassword: {
      required,
	  valid: function (value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        const containsSpecial = /[ §"()=#?!@$%^&₹*-/_:;.'<>`[~{}|]/.test(value);
        return (
            containsUppercase &&
            containsLowercase &&
            containsNumber &&
            containsSpecial
        );
	  },
	  maxLength: maxLength(20),
	  minLength: minLength(8)
    },
},
created() {
    this.submitted = true;
},
computed: {
    isDisabled() {
      return this.$v.$invalid;
    },
},
methods: {
    async ChangePassword() {
      this.response = await this.$store
        .dispatch('account/changePassword', {
          old: this.currentPassword,
          new: this.newPassword
        })
        if(this.response.type === 'success') {
          this.$refs.modalSuccess.open()
		  this.submitted = true;
        } else {
          this.$refs.modalError.open()
        }
		this.submitted = true;
      this.$v.$touch()
      if (this.$v.$invalid) {
		  return false; // stop here if form is invalid
        // console.log("form submitted:", this.email);
      }
    },
    resetErrorMessage() {
      if (this.error) this.error = null
    },
    switchVisibility(type) {
      if(type === 'current')
        this.currentPasswordFieldType = this.currentPasswordFieldType === 'password' ? 'text' : 'password'
      else
        this.newPasswordFieldType = this.newPasswordFieldType === 'password' ? 'text' : 'password'
    }
  },
}
</script>

<style lang="css" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
}

.formWrapper {
  width: auto;
  max-width: 300px;
}

input::placeholder {
  font-size: 0.8rem;
}

.login-btn {
	background: var(--primaryDark);
	color: var(--bright) !important;
	text-decoration: none;
	text-transform: uppercase;
	font-weight: 500;
	letter-spacing: 2px;
	padding: 10px 20px;
	border-radius: 5px;
	transition: 0.3s;
	transition-property: background;
}

.login-btn:hover {
	background: var(--primary);
}

.logo-img path {
  fill: var(--primaryDark);
}
.wrapper {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 60% 1fr;
  color: #696969;
}

.eyeIcon {
  position: absolute;
  top: 20px;
  right: 20px;
}

.error-boarder {
  border: 2px solid var(--primaryDark);
}

.signInLogo {
  width: 40%;
  margin-bottom: 2em;
}
.cls-1 {
  fill: var(--primary);
}

.shadow {
  -webkit-filter: drop-shadow(3px 4px 4px rgba(0, 0, 0, 0.29));
  filter: drop-shadow(3px 4px 4px rgba(0, 0, 0, 0.29));
  /* Similar syntax to box-shadow */
}
section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px;
}
.error {
  background-color: none !important;
  border-color: none !important;
}
.errorMessage {
  margin-bottom: 2em;
  margin-top: -20px;
  color: var(--primaryDark);
}
.forgotPass {
  color: var(--primaryDark) !important;
  background-color: none !important;
  text-decoration-line: none;
}

.close {
  position: absolute;
  left: 15px;
  top: 15px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}

.side {
  background: linear-gradient(
    16deg,
    rgba(76, 158, 134, 1) 0%,
    rgba(61, 113, 109, 1) 8%,
    rgba(47, 71, 85, 1) 38%,
    rgba(44, 62, 80, 1) 47%,
    rgba(44, 62, 80, 1) 50%,
    rgba(44, 62, 80, 1) 80%
  ); /* background: url("../assets/static/images/background.png")no-repeat; */
  height: 100%;
}

.side img {
  width: 30%;
}

.side p {
  max-width: 500px;
  color: #ddfdff;
  letter-spacing: 1px;
  line-height: 1.8em;
  margin-bottom: 40px;
}

.side .main-msg {
  color: rgb(96, 204, 172);
  font-size: 3.2em;
  font-weight: bold;
  line-height: 1.5em;
  margin-bottom: 20px;
}

.title {
  font-size: 3em !important;
  font-weight: bold;
  text-align: center;
  letter-spacing: 1px;
  color: var(--bg);
}

.divider {
  color: var(--bg);
  width: 100%;
  text-align: center;
}

.divider hr {
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}

.left {
  float: left;
}

.right {
  float: right;
}

.welcome-message {
  text-align: center;
  font-size: 1.1em;
  line-height: 28px;
  margin-bottom: 10px;
}

form {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
}

.form-control {
    width: 100%;
    position: relative;
    margin-bottom: 50px;
    border: none !important;
    /* margin-left: 50px; */
    margin-top: 50px;
}

input,
button {
  border: none;
  outline: none;
  border-radius: 30px;
  font-size: 1.1em;
}

input {
  width: 100%;
  background: #e6e6e6;
  color: #333;
  letter-spacing: 0.5px;
  padding: 14px 64px;
}

input ~ i {
  position: absolute;
  left: 22px;
  top: 80%;
  transform: translateY(-50%);
  color: var(--gray);
  transition: color 0.4s;
  font-size: 1.3em;
}

input:focus ~ i {
  color: #0e484b;
}

button.action {
  color: #fff;
  padding: 14px 64px;
  margin: 32px auto;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: bold;
  background-color: var(--primaryDark);
  background: var(--primaryDark);
  cursor: pointer;
  transition: opacity 0.4s;
}

button.action:hover {
  opacity: 0.9;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999 !important;
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: context-menu;
}


.login {
  position: absolute;
  bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login button {
  margin-left: 16px;
  background: none;
  color: var(--bg);
  border-bottom: 2px solid var(--bg);
  border-radius: 0;
  padding: 4px;
  cursor: pointer;
  font-weight: bold;
}

.login button:hover {
  color: var(--primary);
  border-bottom: 2px solid var(--primary);
}

.login p {
  margin-bottom: 0;
}

/* ----  Responsiveness   ----  */
@media only screen and (max-width: 480px) {
  .section {
    padding: 48px 20px 60px 20px !important;
  }
  .login {
    bottom: 5px;
  }
  .form-control {
    width: 90%;
    margin-bottom: 40px;
    margin-left: 10px;
    margin-top: 20px;
}
.formWrapper {
  width: 100% !important;
  max-width: 400px;
}
}

@media (max-width: 774px) {
  .wrapper {
    grid-template-columns: 1fr;
  }

  .side {
    display: none;
  }
  .section {
    padding-bottom: 0;
    padding-top: 0;
  }
  .tab-content > .tab-pane {
   width: auto !important;
}
card-body {
  padding: 0;
}
.logout_btn {
  width: 100px;
}
}

@media (min-width: 775px) {
  .close {
    display: none;
  }
  .tab-content > .tab-pane {
   width: 100vh;
}
}

/* Landscape */
@media screen 
  and (device-width: 320px) 
  and (device-height: 440px) 
  and (-webkit-device-pixel-ratio: 2) 
  and (orientation: landscape) {
  .tab-content > .tab-pane {
   width: 80vh;
}
.form-control {
  margin-left: 0px !important;
}
}
/* ----------- Galaxy S4, S5 and Note 3 ----------- */
/* Landscape */
@media screen 
  and (device-width: 320px) 
  and (device-height: 640px) 
  and (-webkit-device-pixel-ratio: 3) 
  and (orientation: landscape) {
.form-control {
  margin-left: inherit !important;
  margin-top: inherit !important;
}
}

</style>